module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/line-11@2x.png?1.0.17";